var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{attrs:{"color":_vm.themeColor}},[_c('div',{staticClass:"logo-wrapper pl-3"},[_c('img',{attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"src":_vm.logoSrc}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }